const WITHDRAW_TYPES = [
  {
    label: 'زمان‌دار بدون محدودیت در مبلغ و تعداد دفعات برداشت',
    value: 'WITHDRAW_RULE_TYPE_SUBSCRIPTION',
    daysLimit: true,
    amountLimit: false,
    countLimit: false,
  },
  {
    label: 'زمان‌دار با سقف مبلغ و بدون محدودیت در تعداد دفعات برداشت',
    value: 'WITHDRAW_RULE_TYPE_SUBSCRIPTION_AMOUNT',
    daysLimit: true,
    amountLimit: true,
    countLimit: false,
  },
  {
    label: 'زمان‌دار با سقف مبلغ و تعداد دفعات محدود',
    value: 'WITHDRAW_RULE_TYPE_SUBSCRIPTION_AMOUNT_COUNT',
    daysLimit: true,
    amountLimit: true,
    countLimit: true,
  },
  {
    label: 'با سقف مبلغ و تعداد دفعات محدود و زمان نامحدود',
    value: 'WITHDRAW_RULE_TYPE_AMOUNT_COUNT',
    daysLimit: false,
    amountLimit: true,
    countLimit: true,
  },
  {
    label: 'با سقف مبلغ محدود، زمان و تعداد دفعات نامحدود',
    value: 'WITHDRAW_RULE_TYPE_AMOUNT',
    daysLimit: false,
    amountLimit: true,
    countLimit: false,
  },
];

export default WITHDRAW_TYPES;
